import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { LoginService } from '../../components/login/login.service';
import { DialogRef } from 'angular2-modal';
import { GeoServices } from '../../services/geo.service';
import { UserProfileService } from '../../components/user-profile/user-profile.service';
import { ConfigService } from '../../services/config.service';
import { FormComponentI } from '../../shared/interfaces/form-component-i.interface';
import { InternalStateEvent } from '../../shared/models/internal-state-event';
import { StateMiscArgument } from 'nm-socle-application/app/shared/models/customer-config';
import { FormControl } from '@angular/forms';
import {AbstractComponent} from 'nm-socle-application/app/shared/models/abstract-component';

@Component({
    selector: 'my-password-change',
    templateUrl: './password-change.component.html',
    styleUrls: ['./password-change.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PasswordChangeComponent extends AbstractComponent implements FormComponentI {
    public userProfil: any = {};
    public passw: string;
    public passwConfirm: string;
    public isChangingPwd:boolean = false;

    public passInp = new FormControl();
    public passValid:boolean = false;

    public passCtrlInp = new FormControl();
    public passCtrlValid:boolean = false;

    public token: string;
    public passwordForm:any;

    @Output() public closeEvent: EventEmitter<any> = new EventEmitter();
    @Output() public internalStateEvent: EventEmitter<InternalStateEvent> = new EventEmitter();
    @Input() public misc:StateMiscArgument[] = [];

    constructor(
        public dialog: DialogRef<any>,
        private _loginService: LoginService,
        public userProfileService: UserProfileService,
        public geoServices: GeoServices,
        private _configService: ConfigService,
        protected _cd:ChangeDetectorRef,
    ) {
        super(_cd);

        this.token = (dialog && dialog.context) ? dialog.context.token : "";
        if ( this.token ){
            this._loginService.recoverUser(this.token).subscribe((user) => {
                this.userProfil = user;
                this._configService.put('login', user.user_login);
                this.markForCheck();
            });
        }
    }

    public ngOnInit() {
        super.ngOnInit();

        let evt:InternalStateEvent = new InternalStateEvent({icon: 'fa-user', title: 'password-change.alert'});

        this.internalStateEvent.emit(evt);

        this._loginService.loggedInUser.subscribe((user) => {
            if (user) {
                this.userProfil = user;
            }
            this.markForCheck();
        });

        this._subs.push(this.passInp.statusChanges.subscribe(evt => {
            this.passValid = evt == 'VALID';

            this.markForCheck();
            this._cd.detectChanges();
        }))

        this._subs.push(this.passCtrlInp.statusChanges.subscribe(evt => {
            this.passCtrlValid = evt == 'VALID';

            this.markForCheck();
            this._cd.detectChanges();
        }))
    }

    public submitPasswordChange() {
        this.isChangingPwd = true;
        this.userProfil.passw = this.passw;
        this.userProfil.passwConfirm = this.passwConfirm;

        if ( !this.token )
            return this.userProfileService.updateUser(this.userProfil.user_id, this.userProfil)
                .subscribe((updatedUser) => {
                    return this._onUserUpdate(updatedUser);
                });

        // Password change submission in case of a lost password
        this.userProfileService.encryptUserInformations(this.userProfil);
        return this._loginService.recoverPassword(this.token, this.userProfil)
            .subscribe((updatedUser) => {
                return this._onUserUpdate(updatedUser);
            });
    }

    /**
     * Log in again with the new password
     */
    private _onUserUpdate(updatedUser){

        this.markForCheck();

        this._configService.put('pwd', updatedUser.user_passw);

        this.markForCheck();

        return this._loginService.login().catch((err) => {
            this.isChangingPwd = false;
            this.markForCheck();

            return undefined;
        }).subscribe(() => {
            if (!this.token) {
                this.closeEvent.emit('changePasswordOk');
            }
            else{
                this.dialog.close();
            }
            this.markForCheck();
        });
    }

    public logout() {
        this._loginService.logout();

        window.location.reload();
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/password-change/password-change.component.ts